export default __webpack_public_path__ + "static/media/008-santa hat.89e73633.svg";